import { api } from './api';
import type {
  NotificationTemplate,
  SendToUserRequest,
  SendToMultipleRequest,
  SendBroadcastRequest,
  SendNotificationResponse,
  NotificationHistoryResponse,
  BatchSummary,
  NotificationLogEntry,
} from '../types/notifications';

const BASE_PATH = '/admin/notifications';

export const getTemplates = async (): Promise<NotificationTemplate[]> => {
  const response = await api.get(`${BASE_PATH}/templates`);
  return response.data;
};

export const sendToUser = async (body: SendToUserRequest): Promise<SendNotificationResponse> => {
  const response = await api.post(`${BASE_PATH}/send/user`, body);
  return response.data;
};

export const sendToMultiple = async (body: SendToMultipleRequest): Promise<SendNotificationResponse> => {
  const response = await api.post(`${BASE_PATH}/send/multiple`, body);
  return response.data;
};

export const sendBroadcast = async (body: SendBroadcastRequest): Promise<SendNotificationResponse> => {
  const response = await api.post(`${BASE_PATH}/send/broadcast`, body);
  return response.data;
};

export const getHistory = async (params: { limit: number; offset: number }): Promise<NotificationHistoryResponse> => {
  const response = await api.get(`${BASE_PATH}/history`, { params });
  return response.data;
};

export const getBatchSummary = async (batchId: string): Promise<BatchSummary> => {
  const response = await api.get(`${BASE_PATH}/history/batch/${batchId}`);
  return response.data;
};

export const getLogEntry = async (id: number): Promise<NotificationLogEntry> => {
  const response = await api.get(`${BASE_PATH}/history/${id}`);
  return response.data;
};

export const notificationsService = {
  getTemplates,
  sendToUser,
  sendToMultiple,
  sendBroadcast,
  getHistory,
  getBatchSummary,
  getLogEntry,
};

export default notificationsService;
